export default Object.freeze({
  USERS_LIST: 'USERS_LIST',
  USER_UPDATE_DATA: 'USER_UPDATE_DATA',
  USER_UPDATE: 'USER_UPDATE',
  USER_CREATE: 'USER_CREATE',
  USER_CREATE_DATA: 'USER_CREATE_DATA',
  USER_UPDATE_ACTIVE: 'USER_UPDATE_ACTIVE',
  USER_PROFILE_UPDATE: 'USER_PROFILE_UPDATE',
});
